import { Link } from "react-router-dom";

export const CONTACT_EMAIL = "torontosanskriti@gmail.com";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="mx-auto max-w-2xl px-4 py-6 text-center text-xs text-ink-muted">
    <p>© 2026 TSS · Sharod Shamman People's Choice</p>
    <p className="mt-2 flex justify-center gap-3">
      <Link to="/privacy" data-testid="footer-privacy-link" className="font-semibold text-maroon underline">Privacy Policy</Link>
      <span aria-hidden="true">·</span>
      <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact-link" className="text-maroon underline">{CONTACT_EMAIL}</a>
    </p>
  </footer>
);
